import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityClaim } from "../../entity/EntityClaim";

export class DtoClaimsPostReq extends EntityClaim {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
